import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import PublicIcon from '@material-ui/icons/Public';
import FunctionsIcon from '@material-ui/icons/Functions';
import { useHistory } from 'react-router';
import background from '../assets/images/imagenPrincipalPadroVicente.png';

const useStyles = makeStyles((theme) => ({
  page: {
    minHeight: 'calc(100vh - 64px)',
    padding: '22px 28px 36px',
    backgroundColor: '#eef4fa',
    color: '#14263a',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    boxSizing: 'border-box',
    [theme.breakpoints.down('sm')]: { minHeight: 'calc(100vh - 56px)', padding: '20px 16px 34px' },
  },
  content: { maxWidth: '1280px', margin: '0 auto' },
  pageHeader: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '18px', gap: '16px' },
  eyebrow: { margin: 0, color: '#5c7898', fontSize: '11px', fontWeight: 700, letterSpacing: '0.18em', textTransform: 'uppercase' },
  pageTitle: { margin: '4px 0 0', color: '#172a41', fontSize: '22px', fontWeight: 700, lineHeight: 1.2 },
  onlineStatus: {
    display: 'inline-flex', alignItems: 'center', gap: '8px', padding: '8px 13px', border: '1px solid #a9e5ce',
    borderRadius: '20px', backgroundColor: '#ecfbf4', color: '#087b55', fontSize: '13px', fontWeight: 600, whiteSpace: 'nowrap',
  },
  statusDot: { width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#22c58b', boxShadow: '0 0 0 4px rgba(34, 197, 139, 0.15)' },
  hero: {
    minHeight: '280px', display: 'grid', gridTemplateColumns: 'minmax(0, 1.18fr) minmax(330px, 0.82fr)', overflow: 'hidden', borderRadius: '10px',
    backgroundColor: '#071d31', boxShadow: '0 14px 30px rgba(20, 38, 58, 0.15)',
    [theme.breakpoints.down('sm')]: { gridTemplateColumns: '1fr', minHeight: 'auto' },
  },
  heroContent: { position: 'relative', zIndex: 1, padding: '30px 40px', color: '#ffffff', backgroundColor: '#071d31', [theme.breakpoints.down('sm')]: { padding: '26px 24px' } },
  heroTag: {
    display: 'inline-block', marginBottom: '13px', padding: '5px 9px', border: '1px solid rgba(240, 190, 58, 0.58)', borderRadius: '16px',
    color: '#f3c94d', fontSize: '11px', fontWeight: 700, letterSpacing: '0.15em', textTransform: 'uppercase',
  },
  heroTitle: {
    margin: 0, color: '#ffffff', fontSize: '30px', fontWeight: 700, letterSpacing: 0, lineHeight: 1.16,
    '& span': { color: '#f0c542' }, [theme.breakpoints.down('sm')]: { fontSize: '26px' },
  },
  heroDescription: {
    maxWidth: '470px', margin: '11px 0 0', color: '#b8cadb', fontSize: '14px', lineHeight: 1.55,
    [theme.breakpoints.down('sm')]: { fontSize: '14px' },
  },
  heroActions: { display: 'flex', flexWrap: 'wrap', gap: '9px', marginTop: '19px' },
  heroButton: {
    display: 'inline-flex', alignItems: 'center', gap: '7px', minHeight: '38px', padding: '0 15px', border: '1px solid rgba(202, 220, 236, 0.28)', borderRadius: '20px',
    backgroundColor: 'transparent', color: '#f1f6fb', cursor: 'pointer', fontFamily: 'inherit', fontSize: '13px', fontWeight: 700,
    '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.08)' },
  },
  heroButtonPrimary: { borderColor: '#e7b62d', backgroundColor: '#e7b62d', color: '#102235', '&:hover': { backgroundColor: '#f0c545' } },
  heroStats: { display: 'flex', flexWrap: 'wrap', gap: '18px', marginTop: '20px' },
  heroStat: { color: '#8ea6bb', fontSize: '12px', '& strong': { marginRight: '4px', color: '#f0c542', fontSize: '15px' } },
  heroInstitutional: {
    position: 'relative', minHeight: '280px', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden',
    backgroundImage: `linear-gradient(rgba(7, 29, 49, 0.2), rgba(7, 29, 49, 0.2)), url(${background})`,
    backgroundPosition: 'center', backgroundSize: 'cover',
    [theme.breakpoints.down('sm')]: { minHeight: '190px' },
  },
  sectionHeader: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '16px', margin: '22px 0 12px' },
  sectionTitle: { margin: 0, color: '#4d6e90', fontSize: '13px', fontWeight: 700, letterSpacing: '0.12em', textTransform: 'uppercase' },
  serviceCount: { padding: '5px 10px', border: '1px solid #b7e9d5', borderRadius: '14px', color: '#087b55', fontSize: '11px', fontWeight: 700, whiteSpace: 'nowrap' },
  serviceGrid: {
    display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0, 1fr))', gap: '16px',
    [theme.breakpoints.down('md')]: { gridTemplateColumns: 'repeat(2, minmax(0, 1fr))' },
    [theme.breakpoints.down('xs')]: { gridTemplateColumns: '1fr', gap: '14px' },
  },
  serviceCard: {
    position: 'relative', width: '100%', minHeight: '192px', display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '18px 16px 14px', border: '1px solid #dce6ef',
    borderRadius: '10px', backgroundColor: '#ffffff', color: '#14263a', cursor: 'pointer', fontFamily: 'inherit', textAlign: 'center', overflow: 'hidden',
    transition: 'transform 160ms ease, box-shadow 160ms ease, border-color 160ms ease', boxSizing: 'border-box',
    '&:hover': { borderColor: '#8ebbd5', boxShadow: '0 12px 24px rgba(38, 79, 113, 0.15)', transform: 'translateY(-4px)' },
    '&:focus-visible': { outline: '3px solid rgba(60, 141, 188, 0.32)', outlineOffset: '2px' },
    [theme.breakpoints.down('xs')]: { minHeight: '184px', padding: '17px 14px 13px' },
  },
  serviceTop: { width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' },
  serviceIcon: {
    width: '54px', height: '54px', display: 'grid', placeItems: 'center', border: '1px solid #b9d8ed', borderRadius: '50%', backgroundColor: '#eaf7ff', color: '#137cad',
    boxShadow: 'inset 0 1px 0 rgba(255, 255, 255, 0.85)', transition: 'transform 180ms ease',
    '& svg': { fontSize: '27px' },
  },
  serviceCategory: { position: 'absolute', top: '12px', right: '12px', padding: '4px 8px', border: '1px solid #c4deee', borderRadius: '12px', color: '#2c759a', fontSize: '8px', fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase' },
  serviceTitle: { margin: '10px 0 4px', color: '#14263a', fontSize: '15px', fontWeight: 700, lineHeight: 1.3 },
  serviceDescription: { minHeight: '34px', margin: 0, color: '#668099', fontSize: '11px', lineHeight: 1.45 },
  serviceSeparator: { width: '30px', height: '2px', margin: '9px 0', borderRadius: '2px', backgroundColor: 'currentColor', opacity: 0.18 },
  serviceAction: {
    width: '100%', display: 'inline-flex', alignItems: 'center', justifyContent: 'space-between', gap: '6px', marginTop: 'auto', color: '#187aa7', fontSize: '11px', fontWeight: 700,
    '& svg': { width: '24px', height: '24px', padding: '5px', borderRadius: '7px', backgroundColor: '#eaf7ff', boxSizing: 'border-box', transition: 'transform 160ms ease' },
  },
  serviceDebt: { '& $serviceIcon': { borderColor: '#f5d28a', backgroundColor: '#fff8e8', color: '#ca7b00' }, '& $serviceCategory': { borderColor: '#f2d59a', color: '#ad6700' }, '& $serviceAction': { color: '#b86d00', '& svg': { backgroundColor: '#fff8e8' } }, '&:hover $serviceIcon': { transform: 'scale(1.08)' } },
  serviceGeo: { '& $serviceIcon': { borderColor: '#a9e6d8', backgroundColor: '#ecfbf6', color: '#087c68' }, '& $serviceCategory': { borderColor: '#b8e9dd', color: '#087965' }, '& $serviceAction': { color: '#087965', '& svg': { backgroundColor: '#ecfbf6' } }, '&:hover $serviceIcon': { transform: 'scale(1.08)' } },
  serviceCalculator: { '& $serviceIcon': { borderColor: '#d0ccff', backgroundColor: '#f1f0ff', color: '#554dcc' }, '& $serviceCategory': { borderColor: '#d7d4ff', color: '#5149bd' }, '& $serviceAction': { color: '#5149bd', '& svg': { backgroundColor: '#f1f0ff' } }, '&:hover $serviceIcon': { transform: 'scale(1.08)' } },
}));

const services = [
  { title: 'Consulta de deudas', category: 'Consultas', description: 'Verifica tus obligaciones municipales y gestiona tus pagos pendientes.', icon: AttachMoneyIcon, path: '/consulta_deuda', tone: 'serviceDebt' },
  { title: 'Geoportal', category: 'Mapas', description: 'Consulta información territorial, predial y cartográfica del cantón.', icon: PublicIcon, path: '/geoportal', tone: 'serviceGeo' },
  { title: 'Calculadora de Plusvalía', category: 'Herramientas', description: 'Simula el cálculo de alcabalas y plusvalía de forma rápida y clara.', icon: FunctionsIcon, path: '/calculator', tone: 'serviceCalculator' },
];

function Home() {
  const classes = useStyles();
  const history = useHistory();
  const [showPage, setShowPage] = useState(false);

  useEffect(() => {
    const redirectFromHash = () => {
      const { hash } = window.location;
      if (hash === '#/searching_value=mobile') history.push('/mobileportal');
      else if (hash === '#/searching_value=mobile2') history.push('/geoportalv2');
      else if (hash.startsWith('#/searching_value=deuda')) {
        const query = hash.replace('#/searching_value=deuda', '');
        history.replace(`/consulta_deuda${query}`);
      } else setShowPage(true);
    };

    redirectFromHash();
    window.addEventListener('hashchange', redirectFromHash);
    window.addEventListener('pageshow', redirectFromHash);
    return () => {
      window.removeEventListener('hashchange', redirectFromHash);
      window.removeEventListener('pageshow', redirectFromHash);
    };
  }, [history]);

  if (!showPage) return null;

  return (
    <main className={classes.page}>
      <div className={classes.content}>
        <header className={classes.pageHeader}>
          <div>
            <p className={classes.eyebrow}>Portal ciudadano</p>
            <h1 className={classes.pageTitle}>Inicio</h1>
          </div>
          <div className={classes.onlineStatus}><span className={classes.statusDot} />Servicios disponibles</div>
        </header>

        <section className={classes.hero} aria-labelledby="home-title">
          <div className={classes.heroContent}>
            <span className={classes.heroTag}>GAD Municipal</span>
            <h2 id="home-title" className={classes.heroTitle}>Portal <span>Ciudadano</span> en línea</h2>
            <p className={classes.heroDescription}>Accede a los servicios municipales de Pedro Vicente Maldonado desde un solo lugar.</p>
            <div className={classes.heroActions}>
              <button type="button" className={`${classes.heroButton} ${classes.heroButtonPrimary}`} onClick={() => history.push('/consulta_deuda')}>
                Consultar deudas <ArrowForwardIcon fontSize="small" />
              </button>
              <button type="button" className={classes.heroButton} onClick={() => history.push('/geoportal')}>
                Ver Geoportal
              </button>
            </div>
            <div className={classes.heroStats}>
              <span className={classes.heroStat}><strong>3</strong> servicios</span>
              <span className={classes.heroStat}><strong>24/7</strong> disponible</span>
              <span className={classes.heroStat}><strong>100%</strong> en línea</span>
            </div>
          </div>
          <aside className={classes.heroInstitutional} aria-label="Gobierno Autónomo Descentralizado Municipal de Pedro Vicente Maldonado">
          </aside>
        </section>

        <section aria-labelledby="services-title">
          <div className={classes.sectionHeader}>
            <h2 id="services-title" className={classes.sectionTitle}>Servicios disponibles</h2>
            <span className={classes.serviceCount}>3 activos</span>
          </div>
          <div className={classes.serviceGrid}>
            {services.map((service) => {
              const Icon = service.icon;
              return (
                <button key={service.path} type="button" className={`${classes.serviceCard} ${classes[service.tone]}`} onClick={() => history.push(service.path)}>
                  <div className={classes.serviceTop}>
                    <span className={classes.serviceIcon}><Icon fontSize="large" /></span>
                    <span className={classes.serviceCategory}>{service.category}</span>
                  </div>
                  <h3 className={classes.serviceTitle}>{service.title}</h3>
                  <p className={classes.serviceDescription}>{service.description}</p>
                  <span className={classes.serviceSeparator} />
                  <span className={classes.serviceAction}>Acceder <ArrowForwardIcon /></span>
                </button>
              );
            })}
          </div>
        </section>
      </div>
    </main>
  );
}

export default Home;
